"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import Question from "@/components/Question.vue";
import API from "@ym-framework/api-utils";
import UiForm from "@/components/form/UiForm.vue";
import AddDepartment from "@/views/teamItems/components/dialog/AddDepartment.vue";
import EditDepartment from "@/views/teamItems/components/dialog/EditDepartment.vue";
import UiDialog from "@/components/dialog/UiDialog.vue";
let departManage = class extends Vue {
  constructor() {
    super(...arguments);
    this.data = [];
    this.arr_list = [];
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        yield this.getDepartments();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getDepartments() {
    return __async(this, null, function* () {
      try {
        let data_tree = [];
        let response = yield API.get(
          `api://base.auth/api/v7/departments`
        );
        data_tree.push(response.data);
        this.data = data_tree;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  handleDrop(draggingNode, dropNode, dropType) {
    return __async(this, null, function* () {
      try {
        yield this.formatData(this.data, 0);
        if (dropType === "before" || dropType === "after") {
          let group_ids = [];
          for (let item of this.arr_list) {
            if (item.id === dropNode.data.parent_id) {
              for (let data of item.children) {
                group_ids.push(data.id);
              }
            }
          }
          let response = yield API.put(`api://base.auth/api/v7/department/move`, {
            id: draggingNode.data.id,
            parent_id: dropNode.data.parent_id,
            group_ids
          });
          this.$message.success(
            this.$t(
              "team_management.department_manager.move_department_message"
            )
          );
        }
        if (dropType === "inner") {
          let group_ids = [];
          for (let item of this.arr_list) {
            if (item.id === dropNode.data.id) {
              for (let data of item.children) {
                group_ids.push(data.id);
              }
            }
          }
          let response = yield API.put(`api://base.auth/api/v7/department/move`, {
            id: draggingNode.data.id,
            parent_id: dropNode.data.id,
            group_ids
          });
          this.$message.success(
            this.$t(
              "team_management.department_manager.move_department_message"
            )
          );
        }
        yield this.getDepartments();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  allowDrop(draggingNode, dropNode) {
    if (dropNode.level === 1 || dropNode.level === 5) {
      return false;
    } else {
      return true;
    }
  }
  allowDrag(draggingNode) {
    return draggingNode.data.parent_id !== null;
  }
  formatData(data, i) {
    return __async(this, null, function* () {
      if (i === 0 && this.arr_list.length > 0) {
        this.arr_list = [];
      }
      for (let item of data) {
        item["level"] = i + 1;
        this.arr_list.push(item);
        if (item.hasOwnProperty("children") && item.children.length > 0) {
          this.formatData(item.children, i + 1);
        }
      }
    });
  }
  openeditwindow(data) {
    let _info = {
      department_name: data.label,
      id: data.id
    };
    this._edit_department_dialog.open(_info);
  }
  addchildren(data, e) {
    this.$store.dispatch("matomo", { that: this, e });
    this._add_department_dialog.open(data.id);
  }
  refresh() {
    return __async(this, null, function* () {
      try {
        yield this.getDepartments();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  departmentcommand(command) {
    return __async(this, null, function* () {
      switch (command.method) {
        case "movedepart":
          break;
        case "delete":
          yield this.delete_department(command.item);
          break;
        case "movemember":
          yield this.openmovemember(command.item);
          break;
      }
    });
  }
  delete_department(data) {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("team_management.department_manager.confirm.content", {
            name: data.label
          }),
          this.$t(`deletevddialog.delete_message_title`),
          {
            customClass: "confirm-dark",
            confirmButtonText: this.$t(
              "team_management.department_manager.confirm.confirm"
            ),
            cancelButtonText: this.$t(
              "team_management.department_manager.confirm.cancel"
            ),
            confirmButtonClass: "btn-orange",
            cancelButtonClass: "btn-dark",
            roundButton: true
          }
        ).catch();
        let response = yield API.delete(
          `api://base.auth/api/v1/department/${data.id}`
        );
        this.$message.success(
          this.$t(
            "team_management.department_manager.table.delete_message"
          )
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openmovemember(data) {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("add-department-dialog")
], departManage.prototype, "_add_department_dialog", 2);
__decorateClass([
  Ref("edit-department-dialog")
], departManage.prototype, "_edit_department_dialog", 2);
departManage = __decorateClass([
  Component({
    components: {
      Question,
      UiDialog,
      UiForm,
      AddDepartment,
      EditDepartment
    }
  })
], departManage);
export {
  departManage as default
};
